export default "__VITE_ASSET__CNILUZLU__"